import React, {useMemo} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import InviteTeamMemberModal from "./InviteTeamMemberModal";
import {useTalentTeam} from "../../../providers/TalentTeamProvider";
import TeamMemberTable from "./TeamMemberTable";
import AddTeamMemberModal from "../../suppliers/components/AddTeamMemberModal";
import {useAuth} from "../../../providers/AuthProvider";
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons";

const TeamRosterStep = (props) => {

    const {auth} = useAuth();

    const {team, onChange, isUpdating} = useTalentTeam();
    const navigate = useNavigate();
    const params = useParams();

    const otherTeamMembers = TB.filter(team?.positions || [], pos => pos?.user?.id !== auth.id);

    const positionsInvites = useMemo(() => {
        return (team?.positions || []).length + (team?.pending_invites || []).length
    }, [isUpdating, team]);

    const rolesFilledForServices = team.rolesFilledForServices();
    const rolesMissingForServices = team.rolesMissingForServices();

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Team Roster {positionsInvites > 1 ? `(${positionsInvites})` : ''}
                            </h3>
                        </div>

                        <div className="flex flex-row justify-between items-center pb-4">
                            <h5 className="form-subtitle">
                                Manage your team members
                            </h5>

                            {(auth.canManageTalent() ? team.is_supplied_by_client : auth.canManageClientResourceTalent()) ?
                                <AddTeamMemberModal/> :
                                <InviteTeamMemberModal/>
                            }

                        </div>

                    </div>
                </div>
            </div>

            <TeamMemberTable hideAuth={false} hideInvite={true} split={false}/>


            {(rolesFilledForServices?.length > 0 || rolesMissingForServices?.length > 0) && (
                <div className="bg-white mt-5 px-6 py-7 flex flex-col gap-3">
                    <div>
                        <p className="text-base font-semibold mb-2">
                            Required Roles
                        </p>
                        <p className="text-xs">
                            Based upon the project types you selected, your team is missing {TB.pluralize("role", rolesMissingForServices?.length,true)} to form a complete, approved team.
                        </p>
                    </div>
                    {rolesFilledForServices?.length > 0 && (
                        <div className="flex flex-row flex-wrap gap-y-3 justify-start mt-3">
                            {TB.map(rolesFilledForServices, role => (
                                <div key={role.id} className="flex flex-row flex-nowrap items-center gap-3 basis-full sm:basis-1/2 md:basis-1/3 pr-2">
                                    <CheckCircleFilled className="text-success" style={{fontSize: 24}}/>
                                    <p className="whitespace-no-wrap font-medium text-sm">{role.name}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {rolesFilledForServices?.length > 0 && rolesMissingForServices?.length && (
                        <hr/>
                    )}
                    {rolesMissingForServices?.length > 0 && (
                        <div className="flex flex-row flex-wrap gap-y-3 justify-start">
                            {TB.map(rolesMissingForServices, role => (
                                <div key={role.id} className="flex flex-row flex-nowrap items-center gap-3 basis-full sm:basis-1/2 md:basis-1/3 pr-2">
                                    <CloseCircleFilled className="text-danger" style={{fontSize: 24}}/>
                                    <p className="whitespace-no-wrap font-medium text-sm">{role.name}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

        </div>
    );
}

export default TeamRosterStep;